"use client";
import "@/components/help/help-navbar.css";
import "@/components/ui/molecules/categories/page-chrome.css";
import "@/components/ui/atoms/categories/data-display.css";

import { HelpSearch } from "@/components/help/HelpSearch";
import { DisputeWellLogo } from "@/components/ui/molecules/OrgLogo";
import { useAuth } from "@/components/ui/providers/auth-provider";
import { Button } from "@/components/ui/shadcn/button";
import { routes } from "@/lib/routing/routes";
import { getCrmUrl } from "@/lib/routing/urls";
import Link from "next/link";

import { memo } from "react";

export const HelpNavbar = memo(function HelpNavbar() {
    const { user, loading } = useAuth();

    return (
        <header className="dw-help-navbar dw-bar" data-component="HelpNavbar" data-location="src/components/help/HelpNavbar.tsx">
            <div className="dw-help-navbar__inner">
                {/* Left: Logo and Nav */}
                <div className="dw-help-navbar__left">
                    <Link href="/" className="dw-help-navbar__logo">
                        <DisputeWellLogo width={100} height={28} className="dw-help-navbar__logo-img"/>
                    </Link>
                    <nav aria-label="Help navigation" className="dw-help-navbar__nav">
                        <Link href="/help" className="dw-help-navbar__nav-link dw-quiet-link dw-text-body" data-tone="primary">Disputing Education</Link>
                        <Link href="/help/faq" className="dw-help-navbar__nav-link dw-quiet-link dw-text-body" data-tone="muted">FAQ</Link>
                    </nav>
                </div>

                {/* Center: Search */}
                <div className="dw-help-navbar__center">
                    <HelpSearch />
                </div>

                {/* Right: Auth buttons */}
                <div className="dw-help-navbar__right">
                    {loading ? <div className="dw-help-navbar__skeleton dw-skeleton" /> : user
                        ? (
                            <Button asChild size="sm">
                                <Link href={routes.crm.dashboard}>Dashboard</Link>
                            </Button>
                        )
                        : (
                            <>
                                <Link href={process.env.DW_CRM_LOGIN} className="dw-help-navbar__signin dw-quiet-link dw-text-body" data-tone="muted">Sign in</Link>
                                <Button asChild size="sm">
                                    <Link href={getCrmUrl(routes.crm.signup)}>Sign up</Link>
                                </Button>
                            </>
                        )}
                </div>
            </div>
        </header>
    );
});
